import { memo, useMemo } from "react"
import type { CSSProperties } from "react"
import { LOADING_ROBOT_SVG } from "./loading-robot-svg"
import "./style.scss"

// Must match the number of nth-child selectors in style.scss
const ORBIT_DOT_COUNT = 7
const BASE_LOADER_WIDTH = 156

interface LoadingArtifactIndicatorProps {
  message: string
  size?: number
}

export const LoadingArtifactIndicator = memo(function LoadingArtifactIndicator({ message, size = BASE_LOADER_WIDTH }: LoadingArtifactIndicatorProps) {
  const loaderStyles = useMemo(() => ({
    "--ai-artifact-loader-scale": size > 0 ? size / BASE_LOADER_WIDTH : 1,
  } as CSSProperties), [size])

  return (
    <div
      className="loading-artifact-indicator ai-artifact-module__state ai-artifact-module__status"
      style={loaderStyles}
    >
      <div className="loading-artifact-indicator__visual">
        <div className="loading-artifact-indicator__canvas">
          <div
            className="loading-artifact-indicator__image"
            role="img"
            aria-label="Loading robot"
            dangerouslySetInnerHTML={{ __html: LOADING_ROBOT_SVG }}
          />
          <div className="loading-artifact-indicator__orbit-layer" aria-hidden="true">
            {Array.from({ length: ORBIT_DOT_COUNT }).map((_, index) => (
              <span
                key={`orbit-dot-${index + 1}`}
                className="loading-artifact-indicator__orbit-dot"
              />
            ))}
          </div>
        </div>
      </div>
      <p>{message}</p>
    </div>
  )
})
